import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, className, y = 28 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.75, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ eyebrow, title, subtitle, dark = false }) => (
  <div className="max-w-3xl">
    <Reveal>
      <p className={`font-mono2 text-xs uppercase tracking-[0.3em] flex items-center gap-3 ${dark ? "text-[#D96B27]" : "text-[#0D0F12]"}`}>
        <span className="w-8 h-px bg-current inline-block" />
        {eyebrow}
      </p>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 className={`font-display font-extrabold tracking-tight leading-[1.05] mt-5 text-3xl sm:text-4xl lg:text-5xl ${dark ? "text-[#F4F1EA]" : "text-[#0D0F12]"}`}>
        {title}
      </h2>
    </Reveal>
    {subtitle && (
      <Reveal delay={0.16}>
        <p className={`mt-5 text-base sm:text-lg leading-relaxed ${dark ? "text-slate-300" : "text-[#4a4a45]"}`}>{subtitle}</p>
      </Reveal>
    )}
  </div>
);
